/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { GrFormClose } from "react-icons/gr";
import { RootStateOrAny, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import { CompartilhadosInterface } from "services/api";
import { useExcluirCompartilhamentoLead } from "services/api/AppWeb_Lead/excluir-compartilhamento-lead";
import { AuthState } from "../../../../store/ducks/auth/types";
import * as Styles from "../../styles";

interface Props {
  closeModal: () => void;
  refresh: () => void;
  idLead: string | undefined | any;
  idLeadCorretor: string | undefined | any;
  deleteShareData: CompartilhadosInterface | null;
  idLeadResponsavel: string | undefined | any;
  idCorretorSistemaOrigem: string | undefined | any;
}

const DeleteShareModal = (props: Props) => {
  const { idCorretorSistemaOrigem } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const { mutate, isLoading, isSuccess } = useExcluirCompartilhamentoLead({
    idLeadCorretor: props?.idLeadCorretor,
    body: {
      idsLeadsCompartilhados: props?.deleteShareData?.idCompartilhamento
        ? [props?.deleteShareData?.idCompartilhamento]
        : [],
    },
  });

  const handleDelete = () => {
    mutate();
  };

  useEffect(() => {
    if (isSuccess) {
      props?.closeModal();
      props?.refresh();
      if (idCorretorSistemaOrigem === props?.deleteShareData?.idCorretorAtual) {
        window.location.href = `/transferencia-concluida/${
          props.idCorretorSistemaOrigem === props.idLeadResponsavel
            ? "excluido"
            : "removido"
        }`;
      }
    }
  }, [isSuccess]);

  return (
    <Styles.ContainerDelete>
      <div style={{ padding: 22 }}>
        <Styles.SpaceRow>
          <Styles.Title>Confirmação</Styles.Title>
          <Styles.IconButton
            onClick={() => {
              props?.closeModal();
            }}
          >
            <GrFormClose />
          </Styles.IconButton>
        </Styles.SpaceRow>
        <Styles.SpaceY space={12} />
        <Styles.InfoModalDelete>
          Você realmente deseja{" "}
          <span>
            {props?.idCorretorSistemaOrigem === props?.idLeadResponsavel
              ? "excluir"
              : "remover"}
          </span>{" "}
          o compartilhamento deste Lead?
        </Styles.InfoModalDelete>
      </div>

      <Styles.Footer>
        <Styles.FooterDialog>
          <Styles.Button
            style={{ width: "100%" }}
            variant="outlined"
            onClick={() => {
              props.closeModal();
            }}
          >
            Fechar
          </Styles.Button>

          <Styles.DeleteButton
            style={{
              width: "100%",
              boxShadow: "none",
              color: "#fff !important",
            }}
            onClick={() => handleDelete()}
          >
            {isLoading ? (
              <BeatLoader color="#fff" size={10} />
            ) : props.idCorretorSistemaOrigem === props.idLeadResponsavel ? (
              "Excluir"
            ) : (
              "Remover"
            )}
          </Styles.DeleteButton>
        </Styles.FooterDialog>
      </Styles.Footer>
    </Styles.ContainerDelete>
  );
};

export default DeleteShareModal;
